(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shto-complete-the-look"] && !Shopify.designMode) return;
  try {
    
  /* Complete The Look. Arrows move the row one photo (and wrap round at the ends). Tapping a photo shows its products
     over it; tapping the photo again, anywhere else, Escape or swiping to another photo closes it. The round button
     adds the product with ShtoCart.add (the theme's cart drawer opens); a product with sizes needs one chosen first. */
  (function () {
    function init(root) {
      if (root.shtoLook) return;
      root.shtoLook = true;
      var track = root.querySelector('[data-shto-look-track]');
      var arrows = root.querySelector('[data-shto-look-arrows]');
      var msgEl = root.querySelector('[data-shto-look-messages]');
      var needSize = msgEl ? JSON.parse(msgEl.textContent) : '';
      var open = null;

      /* Fewer looks than fit: centred, no arrows. More: left aligned (the row scrolls), arrows show. */
      function overflow() {
        if (!track) return;
        var over = track.scrollWidth > track.clientWidth + 1;
        track.toggleAttribute('data-overflow', over);
        if (arrows) arrows.toggleAttribute('data-overflow', over);
      }
      overflow();
      if ('ResizeObserver' in window && track) new ResizeObserver(overflow).observe(track);

      /* Where the row can rest: each photo's start (the last ones stop where the row ends). */
      function stops() {
        var looks = track.querySelectorAll('[data-shto-look]');
        var max = track.scrollWidth - track.clientWidth;
        var base = looks.length ? looks[0].offsetLeft : 0;
        var out = [];
        looks.forEach(function (look) { var v = Math.min(max, Math.max(0, look.offsetLeft - base)); if (out.indexOf(v) < 0) out.push(v); });
        return out;
      }
      function move(dir) {
        var list = stops();
        if (!list.length) return;
        var here = track.scrollLeft, target;
        if (dir > 0) target = list.filter(function (v) { return v > here + 2; })[0];
        else target = list.filter(function (v) { return v < here - 2; }).pop();
        if (target === undefined) target = dir > 0 ? list[0] : list[list.length - 1];
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
      var prev = root.querySelector('[data-shto-look-prev]');
      var next = root.querySelector('[data-shto-look-next]');
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });

      function setOpen(look, on) {
        var toggle = look.querySelector('[data-shto-look-toggle]');
        if (!toggle) return;
        if (on) look.setAttribute('data-open', ''); else look.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
        open = on ? look : (open === look ? null : open);
        // The arrows would sit on the open product list (its add buttons): they fade out while a look is open.
        if (open) root.setAttribute('data-look-open', ''); else root.removeAttribute('data-look-open');
      }
      function close() { if (open) setOpen(open, false); }

      root.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-shto-look-toggle]');
        if (toggle) {
          var look = toggle.closest('[data-shto-look]');
          var was = look.hasAttribute('data-open');
          close();
          if (!was) setOpen(look, true);
          return;
        }
        var add = event.target.closest('[data-shto-look-add]');
        if (add) addToBag(add);
      });
      document.addEventListener('click', function (event) {
        if (open && !open.contains(event.target)) close();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !open) return;
        var toggle = open.querySelector('[data-shto-look-toggle]');
        var inside = open.contains(document.activeElement);
        close();
        if (inside && toggle) toggle.focus();
      });
      var startLeft = null;
      track.addEventListener('scroll', function () {
        if (!open) { startLeft = null; return; }
        if (startLeft === null) startLeft = track.scrollLeft;
        if (Math.abs(track.scrollLeft - startLeft) > 40) { startLeft = null; close(); }
      }, { passive: true });

      root.addEventListener('change', function (event) {
        var select = event.target.closest('[data-shto-look-size]');
        if (!select) return;
        var item = select.closest('[data-shto-look-item]');
        var option = select.options[select.selectedIndex];
        item.setAttribute('data-variant', select.value);
        select.removeAttribute('data-invalid');
        status(item, '');
        var price = item.querySelector('[data-shto-look-price]');
        var compare = item.querySelector('[data-shto-look-compare]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
      });

      function status(item, text) {
        var el = item.querySelector('[data-shto-look-status]');
        if (el) el.textContent = text;
      }
      function addToBag(button) {
        var item = button.closest('[data-shto-look-item]');
        var id = item.getAttribute('data-variant');
        var select = item.querySelector('[data-shto-look-size]');
        if (!id) {
          if (select) {
            select.setAttribute('data-invalid', '');
            status(item, needSize);
            select.focus();
            try { if (select.showPicker) select.showPicker(); } catch (e) {}
          }
          return;
        }
        if (button.getAttribute('aria-busy') === 'true' || !window.ShtoCart) return;
        button.setAttribute('aria-busy', 'true');
        status(item, '');
        window.ShtoCart.add([{ id: Number(id), quantity: 1 }])
          .catch(function (error) { status(item, error.message); })
          .then(function () { button.removeAttribute('aria-busy'); });
      }
    }
    function initAll(scope) { (scope || document).querySelectorAll('[data-shto-look-root]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-more-to-discover"] && !Shopify.designMode) return;
  try {
    
  /* Loads the recommended products once the page has loaded (the Section Rendering API renders this section's cards),
     then wires the arrows. Swiping is assets/shto-swipe.js; hearts are assets/shto-wish.js. */
  (function () {
    var SEL = '[data-shto-section="shto-more-to-discover"]';
    function smooth() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    function cards(track) { return Array.prototype.filter.call(track.children, function (c) { return c.offsetWidth > 0; }); }
    function fits(section, track) { section.toggleAttribute('data-shto-more-fits', track.scrollWidth <= track.clientWidth + 1); }

    function step(track, dir) {
      var list = cards(track);
      if (list.length < 2) return;
      var pitch = list[1].offsetLeft - list[0].offsetLeft;
      var per = Math.max(1, Math.round(track.clientWidth / pitch));
      var max = track.scrollWidth - track.clientWidth;
      if (max < 1) return;
      var here = track.scrollLeft, target;
      if (dir > 0) target = here >= max - 1 ? 0 : Math.min(max, (Math.round(here / pitch) + per) * pitch);
      else target = here <= 1 ? max : Math.max(0, (Math.round(here / pitch) - per) * pitch);
      track.scrollTo({ left: target, behavior: smooth() });
    }

    function ready(section, track) {
      if (window.ShtoWish) window.ShtoWish.paint(section);
      if (window.ShtoSwipe) window.ShtoSwipe.init(section);
      fits(section, track);
    }

    function load(section, track) {
      var url = section.getAttribute('data-url');
      if (!url) { section.hidden = true; return; }
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-shto-more-track]');
          if (!fresh || !fresh.querySelector('[data-shto-more-card]')) { section.hidden = true; return; }
          track.innerHTML = fresh.innerHTML;
          track.scrollLeft = 0;
          section.setAttribute('data-shto-more-loaded', '');
          ready(section, track);
        })
        .catch(function () { section.hidden = true; });
    }

    function setup(section) {
      if (section.shtoMore) return;
      section.shtoMore = true;
      var track = section.querySelector('[data-shto-more-track]');
      if (!track) return;
      section.querySelectorAll('[data-shto-more-step]').forEach(function (b) {
        b.addEventListener('click', function () { step(track, +b.getAttribute('data-shto-more-step')); });
      });
      window.addEventListener('resize', function () { fits(section, track); }, { passive: true });
      if (section.hasAttribute('data-shto-more-performed')) { ready(section, track); return; }
      if (document.readyState === 'complete') load(section, track);
      else window.addEventListener('load', function () { load(section, track); }, { once: true });
    }

    function init(root) {
      if (root.matches && root.matches(SEL)) setup(root);
      (root.querySelectorAll ? root : document).querySelectorAll(SEL).forEach(setup);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-pdp"]) return;
  try {
    
  /* A copied or reloaded address must open at the top (Kevin 2026-10-02). If it ends in one of our ids (#shto-...), the browser
     would open the page scrolled to that element: back to the top once the page has loaded. The address itself is left alone. */
  (function () {
    if (!/^#shto-/.test(location.hash)) return;
    var top = function () { window.scrollTo(0, 0); };
    if (document.readyState === 'complete') top();
    else window.addEventListener('load', function () { top(); setTimeout(top, 60); }, { once: true });
  })();

  /* Desktop: the right column stays in view while the photos scroll (Figma "affixed-container").
     It is taller than most screens, so it sticks by its bottom edge once scrolled to its end, the way a long
     sticky sidebar should. Only the top offset is set here; the browser does the sticking. */
  (function () {
    function fit(info) {
      var top = 0;
      var sticky = document.querySelector('[data-header-sticky="sticky"], .header--sticky');
      if (sticky) top = sticky.getBoundingClientRect().height;
      var gap = window.innerHeight - info.offsetHeight;
      info.style.setProperty('--shto-info-top', Math.min(top, gap) + 'px');
    }
    function init(root) {
      (root || document).querySelectorAll('[data-shto-pdp-info]').forEach(function (info) {
        fit(info);
        if ('ResizeObserver' in window) new ResizeObserver(function () { fit(info); }).observe(info);
        window.addEventListener('resize', function () { fit(info); }, { passive: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shto-seen-on-you"] && !Shopify.designMode) return;
  try {
    
  /* Seen On You. The row: video cards loop muted while they're on screen (not with reduced motion or data saver); the
     arrows (desktop) step one card and hide at either end (shto-swipe.js does the dragging). Tapping a card opens the
     expanded view on that card; its video plays with sound (muted if the browser refuses sound; a tap then turns it on),
     and swiping or the arrows / arrow keys move to the next one, which starts playing. */
  (function () {
    var quiet = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
      (navigator.connection && navigator.connection.saveData);

    /* One rendition of an adaptive stream: the tallest at most `cap` pixels high (else the smallest), read from the
       master playlist. Any trouble: the master playlist itself, as before. */
    var renditions = {};
    function rendition(master, cap) {
      var key = master + '|' + cap;
      if (!renditions[key]) {
        var base = new URL(master, location.href);
        renditions[key] = fetch(base.href).then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        }).then(function (text) {
          var lines = text.split('\n'), best = null, least = null;
          for (var i = 0; i < lines.length; i++) {
            var match = /^#EXT-X-STREAM-INF:.*RESOLUTION=\d+x(\d+)/.exec(lines[i]);
            var uri = (lines[i + 1] || '').trim();
            if (!match || !uri || uri.charAt(0) === '#') continue;
            var height = Number(match[1]);
            if (height <= cap && (!best || height > best.height)) best = { height: height, uri: uri };
            if (!least || height < least.height) least = { height: height, uri: uri };
          }
          var chosen = best || least;
          return chosen ? new URL(chosen.uri, base).href : master;
        }).catch(function () { return master; });
      }
      return renditions[key];
    }

    function setup(root) {
      if (root.shtoSeen) return;
      root.shtoSeen = true;
      var row = root.querySelector('[data-seen-row]');
      var dialog = root.querySelector('[data-seen-dialog]');
      if (!row || !dialog) return;
      var track = dialog.querySelector('[data-seen-track]');
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-seen-slide]'));
      var prev = dialog.querySelector('[data-seen-go="-1"]');
      var next = dialog.querySelector('[data-seen-go="1"]');
      var stepBack = root.querySelector('[data-seen-step="-1"]');
      var stepOn = root.querySelector('[data-seen-step="1"]');
      var current = 0, settle = null;

      /* Fewer posts than fit: centred, no arrows. More: the row scrolls, arrows show (and hide at either end). */
      var arrows = root.querySelector('.shto-seen-on-you__arrows');
      function ends() {
        if (!stepBack || !stepOn) return;
        stepBack.disabled = row.scrollLeft <= 1;
        stepOn.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
      }
      function overflow() {
        var over = row.scrollWidth > row.clientWidth + 1;
        row.toggleAttribute('data-overflow', over);
        if (arrows) arrows.toggleAttribute('data-overflow', over);
        ends();
      }
      overflow();
      if ('ResizeObserver' in window) new ResizeObserver(overflow).observe(row);
      row.addEventListener('scroll', ends, { passive: true });

      root.querySelectorAll('[data-seen-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var card = row.children[0];
          if (!card) return;
          var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
          row.scrollBy({ left: Number(button.getAttribute('data-seen-step')) * (card.offsetWidth + gap), behavior: 'smooth' });
        });
      });

      /* Card loops. Where the browser plays the adaptive stream natively, the card gets one fixed size from it (480p on
         phones, 720p on desktop) so a small card never climbs to the 1080p stream; elsewhere the mp4. The file is set
         shortly before the card scrolls into view (200px ahead, 800px once the page has loaded and gone idle); the loop
         plays while at least half the card is on screen and pauses when it leaves (or the expanded view is open). */
      var loops = Array.prototype.slice.call(row.querySelectorAll('video.shto-seen-on-you__loop'));
      var visible = new Set();
      function prepare(video) {
        if (!video.shtoReady) {
          var hls = video.getAttribute('data-hls');
          var pick = hls && video.canPlayType('application/vnd.apple.mpegurl')
            ? rendition(hls, window.matchMedia('(min-width: 990px)').matches ? 720 : 480)
            : Promise.resolve(video.getAttribute('data-src'));
          video.shtoReady = pick.then(function (src) { video.src = src; });
        }
        return video.shtoReady;
      }
      function loopPlay(video) {
        if (quiet || dialog.open) return;
        prepare(video).then(function () {
          if (dialog.open || !visible.has(video)) return;
          video.muted = true;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        });
      }
      loops.forEach(function (video) {
        var card = video.closest('.shto-seen-on-you__card');
        video.addEventListener('playing', function () { card.classList.add('is-looping'); });
      });
      if (!quiet && loops.length && 'IntersectionObserver' in window) {
        var ahead = null;
        var lookAhead = function (margin) {
          if (ahead) ahead.disconnect();
          ahead = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              ahead.unobserve(entry.target);
              entry.target.preload = 'auto';
              prepare(entry.target);
            });
          }, { rootMargin: margin + ' 0px' });
          loops.forEach(function (video) { if (!video.shtoReady) ahead.observe(video); });
        };
        lookAhead('200px');
        var widen = function () {
          var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 500); };
          idle(function () { lookAhead('800px'); }, { timeout: 2000 });
        };
        if (document.readyState === 'complete') widen(); else window.addEventListener('load', widen, { once: true });
        var watcher = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) { visible.add(video); loopPlay(video); }
            else { visible.delete(video); if (!video.paused) video.pause(); }
          });
        }, { threshold: 0.5 });
        loops.forEach(function (video) { watcher.observe(video); });
      }
      function loopsPause() { loops.forEach(function (video) { if (!video.paused) video.pause(); }); }
      function loopsResume() { visible.forEach(loopPlay); }

      /* Expanded view: one video element, moved into whichever slide is showing. It lets go of the last file when it
         moves on or the view closes, so only one video is ever held in memory. */
      var player = document.createElement('video');
      player.loop = true;
      player.playsInline = true;
      player.preload = 'auto';
      player.setAttribute('playsinline', '');
      player.setAttribute('disablepictureinpicture', '');
      var holder = null;
      function release() {
        if (!holder) return;
        player.pause();
        player.removeAttribute('src');
        player.load();
        holder.classList.remove('is-playing', 'is-started', 'is-muted');
        holder = null;
      }
      function start(index) {
        var slide = slides[index], media = slide && slide.querySelector('[data-seen-toggle]');
        if (!media) { release(); return; }
        if (holder !== slide) {
          release();
          holder = slide;
          var still = media.querySelector('img');
          media.insertBefore(player, still ? still.nextSibling : media.firstChild);
          player.src = media.getAttribute('data-src');
        }
        player.muted = false;
        slide.classList.remove('is-muted');
        var p = player.play();
        if (p && p.catch) p.catch(function () {
          if (holder !== slide) return;
          // No sound allowed without a tap here: play muted and show the muted badge; a tap turns sound on.
          player.muted = true;
          slide.classList.add('is-muted');
          var q = player.play();
          if (q && q.catch) q.catch(function () { if (holder === slide) slide.classList.remove('is-playing'); });
        });
      }
      function stop(index) { if (holder && holder === slides[index]) release(); }
      function stopAll() { release(); }
      player.addEventListener('play', function () { if (holder) holder.classList.add('is-playing'); });
      player.addEventListener('playing', function () { if (holder) holder.classList.add('is-started'); });
      player.addEventListener('pause', function () { if (holder) holder.classList.remove('is-playing'); });
      function place(index, smooth) {
        index = Math.max(0, Math.min(slides.length - 1, index));
        if (index !== current) stop(current);
        current = index;
        track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: smooth ? 'smooth' : 'instant' });
        paint();
        start(index);
      }
      function paint() {
        prev.disabled = current <= 0;
        next.disabled = current >= slides.length - 1;
      }

      row.addEventListener('click', function (event) {
        var button = event.target.closest('[data-seen-open]');
        if (!button) return;
        slides.forEach(function (slide) { var img = slide.querySelector('img'); if (img) img.loading = 'eager'; });
        loopsPause();
        dialog.showModal();
        document.documentElement.classList.add('shto-lock');
        current = -1;
        place(Number(button.getAttribute('data-seen-open')), false);
      });
      dialog.addEventListener('close', function () {
        stopAll();
        document.documentElement.classList.remove('shto-lock');
        loopsResume();
      });
      dialog.querySelector('[data-seen-close]').addEventListener('click', function () { dialog.close(); });
      // A click on the dimmed page around the card (desktop) closes it.
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
      prev.addEventListener('click', function () { place(current - 1, true); });
      next.addEventListener('click', function () { place(current + 1, true); });
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); place(current - 1, true); }
        else if (event.key === 'ArrowRight') { event.preventDefault(); place(current + 1, true); }
      });
      // After a swipe settles: the slide now showing starts, the one left behind stops.
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var width = track.clientWidth || 1;
          var index = Math.round(track.scrollLeft / width);
          if (index !== current) { stop(current); current = index; paint(); start(index); }
        }, 120);
      }, { passive: true });

      slides.forEach(function (slide, index) {
        var toggle = slide.querySelector('[data-seen-toggle]');
        if (!toggle) return;
        function flip() {
          if (holder !== slide) { start(index); return; }
          if (player.muted && !player.paused) { player.muted = false; slide.classList.remove('is-muted'); return; }
          if (player.paused || player.ended) {
            player.muted = false;
            slide.classList.remove('is-muted');
            var playing = player.play();
            if (playing && playing.catch) playing.catch(function () { slide.classList.remove('is-playing'); });
          } else player.pause();
        }
        toggle.addEventListener('click', flip);
        toggle.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); flip(); }
        });
      });
    }
    function init(scope) { (scope || document).querySelectorAll('[data-seen-root]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
